import axios from 'axios';
import { toast } from 'sonner';

import useAuth from '../guards/authGuard/UseAuth';
import { decodeToken } from 'react-jwt';

const axiosServices = axios.create();
const refreshUrl = 'refresh-access-token';

// interceptor for http
const AxiosInterceptor = ({ children }) => {
  const { logout, refreshToken, isAuthenticated  } = useAuth();

  // set jwt token to header
  axiosServices.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem('token');
      const refreshToken = localStorage.getItem('refresh-token');

      if (refreshToken && config.url.endsWith(refreshUrl)) {
        config.headers.Authorization = `Bearer ${refreshToken}`;
      } else if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }

      const userFromToken = decodeToken(token);
      if (userFromToken && userFromToken.tenants && userFromToken.tenants.length > 0) {
        config.headers['x-tenant-id'] = userFromToken.tenants[0].tenantId;
      }

      return config;
    },
    async (error) => {
      return Promise.reject(error);
    },
  );

  // refresh token if 401 status
  axiosServices.interceptors.response.use(
    (res) => {
      return res;
    },
    async (err) => {
      const originalConfig = err.config;

      if (err.response) {
        // refresh token expired
        if (
          (err.response.status === 401 && err.request.responseURL.endsWith(refreshUrl)) ||
          (err.response.status === 403 && err.response.data)
        ) {
          logout();
        }

        // Access Token was expired
        else if (err.response.status === 401 && !originalConfig._retry && isAuthenticated) {
          originalConfig._retry = true;

          try {
            await refreshToken();

            return axiosServices(originalConfig);
          } catch (_error) {
            return Promise.reject(_error);
          }
        } else {
          // show toast with error message
          if (!err.config._errorToasted) {
            err.config._errorToasted = true;

              if (!window.location.href.includes('login') && !window.location.href.includes('forgot-password')) {
                  toast.error(
                      (err.response.data && err.response.data.data && err.response.data.data[0]?.constraints?.matches) || err.response.data.message ||
                      err.response.data.detail ||
                      'Unknown error' ||
                      err.response.data.status,
                  );
              }
          }
        }
      }

      return Promise.reject(err);
    },
  );

  return children;
};

export default axiosServices;
export { AxiosInterceptor };
